export const THEMES = [
  { id: "default", label: "Default" },
  { id: "chalk-board", label: "Chalk & Board" },
  { id: "pixar-light", label: "Pixar Light" },
  { id: "retro-80s", label: "Retro 80s" },
];

export function getTheme() {
  try { return localStorage.getItem("ponderr_theme") || "default"; } catch { return "default"; }
}

export function setTheme(id) {
  try { localStorage.setItem("ponderr_theme", id); } catch { /* ignore */ }
  document.documentElement.setAttribute("data-theme", id);
  window.dispatchEvent(new CustomEvent("ponderr-theme", { detail: id }));
}
